import FullscreenLoader from './fullscreen-loader';

export default FullscreenLoader;
